module.exports = __webpack_public_path__ + "img/item10.109fa53e.png";